import { ReduxState } from "reducers/rootReducer";

//if you want a POST you only need apiCall(url, {body:json})
//if you want a GET you only need apiCall(url)
const callPaymentApi = (uri, { body = undefined, contentType = undefined, method = 'GET', processor = undefined } = {}) => (_dispatch, getState) => {
  const state: ReduxState = getState();
  const catereaseUser = !state.oidc.user && state.caterease.catereaseCP;
  const token = catereaseUser
    ? state.caterease.catereaseCP
    : state.oidc.user.access_token;

  const url = `${window.env.REACT_APP_PAYMENT_API_URL}${uri}`;

  if (body) {
    if (!contentType || contentType === 'application/json') {
      body = JSON.stringify(body);
    }
    if (method === 'GET') {
      method = 'POST';
    }
  }

  const headers = {
    Authorization: `Bearer ${token}`,
    'Processor': processor,
    'Content-Type': 'application/json',
    'HPay-Api-Key': window.env.REACT_APP_PAYMENT_API_KEY,
  };

  return callApiWithAuth(url, headers, body, method);
};

const callApiWithAuth = (url, headers, body, method) => {
  return new Promise((resolve, reject) => {
    fetch(url, {
      method,
      headers,
      body,
    })
      .then(result => {
        // if (result.status === 401) {
        //   reject(result);
        //   window.location.replace('/Error/Unauthorized');
        // }
        resolve(result);
      })
      .catch(result => {
        reject(result);
      });
  });
};

export default callPaymentApi;
export { callPaymentApi };
